<template>
  <div class="page">
    <div class="container">
      <div class="top">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-document-add"
          @click="$router.push({ name: 'goodsAdd' })"
          >添加商品</el-button
        >
      </div>
      <div class="table">
        <el-table
          :data="tableData"
          style="width: 100%;"
          :header-row-style="{
            'border-radius': '5px',
            overflow: 'hidden',
          }"
          :header-cell-style="{
            background: 'rgb(245, 247, 250)',
            color: 'rgb(96, 98, 102)',
          }"
        >
          <!-- <el-table-column align="center" width="50" label="序号">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 + page_size * (page_no - 1) }}</span>
            </template>
          </el-table-column> -->
          <el-table-column
            v-for="item in tableTitle"
            :key="item.value"
            :prop="item.value"
            :label="item.label"
            :align="item.align"
            :width="item.width"
          >
            <template slot-scope="scope">
              <div
                v-if="item.value === 'pictureUrl'"
                @click="methodShowImgDialog(scope.row[item.value])"
              >
                <img class="picImg" :src="scope.row[item.value]" alt="" />
              </div>
              <div
                v-else-if="item.value === 'highPictureUrl'"
                @click="methodShowImgDialog(scope.row[item.value])"
              >
                <img class="picImg" :src="scope.row[item.value]" alt="" />
              </div>
              <div v-else-if="item.value === 'category'">
                {{ categoryMap[scope.row[item.value]] }}
              </div>
              <div v-else-if="item.value === 'state'">
                {{ stateMap[scope.row[item.value]] }}
              </div>
              <div v-else>
                {{ scope.row[item.value] }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
            width="100"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="methodEditGoods(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                size="mini"
                v-if="scope.row.state === 0"
                style="color: #e4393c;"
                @click="adminTmplProductUpdateState(scope.row, 1)"
                >下架</el-button
              >
              <el-button
                type="text"
                size="mini"
                style="color: #2da644;"
                v-else-if="scope.row.state === 1"
                @click="adminTmplProductUpdateState(scope.row, 0)"
                >上架</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page_no"
          background
          :page-sizes="[10, 20, 30, 40]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="imgDialoog">
      <img width="100%" :src="dialogImgSrc" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import {
  adminTmplProductQueryList,
  adminTmplProductUpdateState,
} from '@/api/javaApi'

export default {
  name: 'goodsList',
  data: () => ({
    tableTitle: [
      { label: '排序号', value: 'sort', align: 'center', width: '' },
      { label: '商品信息', value: 'name', align: 'left', width: '' },
      { label: '商品编号', value: 'productNumber', align: 'left', width: '' },
      { label: '商品价格', value: 'cost', align: 'left', width: '' },
      { label: '库存', value: 'inventory', align: 'left', width: '' },
      { label: '消耗星币', value: 'starNum', align: 'left', width: '' },
      { label: '时间', value: 'updateTime', align: 'left', width: '' },
      { label: '商品类型', value: 'category', align: 'center', width: '' },
      { label: '商品状态', value: 'state', align: 'center', width: '' },
      {
        label: '商品实际图',
        value: 'pictureUrl',
        align: 'center',
        width: '120',
      },
      {
        label: '商品预览图',
        value: 'highPictureUrl',
        align: 'center',
        width: '120',
      },
      { label: '提示词', value: 'cueWord', align: 'center', width: '' },
      { label: '操作人', value: 'updater', align: 'center', width: '' },
    ],
    tableData: [],
    stateMap: {
      0: '兑换中',
      1: '下架',
    },
    categoryMap: {
      0: '伴学精灵',
      1: '头像挂件',
      2: '实物',
      3: '头像',
    },
    page_no: 1,
    page_size: 10,
    total: 0,
    imgDialoog: false,
    dialogImgSrc: '',
  }),
  created() {
    this.adminTmplProductQueryList()
  },
  methods: {
    methodShowImgDialog(imgSrc) {
      this.dialogImgSrc = imgSrc
      this.imgDialoog = true
    },
    handleSizeChange(size) {
      this.page_size = size
      this.page_no = 1
      this.adminTmplProductQueryList()
    },
    handleCurrentChange(page) {
      this.page_no = page
      this.adminTmplProductQueryList()
    },
    async adminTmplProductQueryList() {
      const res = await adminTmplProductQueryList({
        pageNum: this.page_no,
        pageSize: this.page_size,
      })
      console.log(res)
      if (res) {
        res.content.forEach((item) => {
          item.pictureUrl =
            this.$store.state.resource.picBaseUrl + item.pictureUrl
          item.highPictureUrl =
            this.$store.state.resource.picBaseUrl + item.highPictureUrl
        })
        this.page_no = res.pageNum
        this.page_size = res.pageSize
        this.total = res.totalSize
        this.tableData = res.content
      }
    },
    async adminTmplProductUpdateState(row, state) {
      console.log(row)
      this.$confirm(`确认要${state === 1 ? '下架' : '上架'}商品吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        adminTmplProductUpdateState({
          id: row.id,
          state,
          updater: this.$store.state.user.userInfo.id,
        }).then((res) => {
          console.log(res)
          this.$message({
            type: 'success',
            message: `${state === 1 ? '下架' : '上架'}成功!`,
          })
          this.adminTmplProductQueryList()
        })
      })
    },
    // 编辑商品
    methodEditGoods(row) {
      console.log(row)
      this.$router.push({
        name: 'goodsEdit',
        query: {
          ...row,
        },
      })
    },
  },
}
</script>
<style scoped lang="scss">
.page {
  display: flex;
  width: 100%;
  min-height: 100%;
  padding: 10px;
  box-sizing: border-box;
  .container {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    width: 100%;
    // height: 100%;
    min-height: 100%;
    padding: 40px 20px 20px;
    background-color: #fff;
    border-radius: 5px;
    .top {
      padding-bottom: 10px;
    }
    .table {
      flex: 1;
      .picImg {
        width: 100px;
      }
    }
    .pagination {
      padding-top: 10px;
      text-align: right;
    }
  }
}
</style>
